var _circle, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChindch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5609,
    cy: 27.2279,
    r: 26.4623,
    fill: "#FF7916"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.2266,
    y: 14,
    width: 3.89151,
    height: 26.4623,
    rx: 1.94575,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.665,
    y: 25.6719,
    width: 3.89151,
    height: 14.7877,
    rx: 1.94575,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5654,
    y: 21.0078,
    width: 3.89151,
    height: 19.4575,
    rx: 1.94575,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChindch);
export default __webpack_public_path__ + "static/media/chiến dịch.c2a6ae8e03aa1e0ada7a035706b024f6.svg";
export { ForwardRef as ReactComponent };